import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "findora_admin_token";

export const getAdminToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setAdminToken = (token) => sessionStorage.setItem(TOKEN_KEY, token);
export const clearAdminToken = () => sessionStorage.removeItem(TOKEN_KEY);

const authHeader = () => ({ Authorization: `Bearer ${getAdminToken()}` });

export const loginAdmin = (password) =>
  axios.post(`${API}/auth/login`, { password }).then((r) => r.data);

export const fetchCustomItems = () =>
  axios.get(`${API}/items`).then((r) => r.data);

export const createItem = (data) =>
  axios.post(`${API}/items`, data, { headers: authHeader() }).then((r) => r.data);

export const updateItem = (id, data) =>
  axios.put(`${API}/items/${id}`, data, { headers: authHeader() }).then((r) => r.data);

export const deleteItem = (id) =>
  axios.delete(`${API}/items/${id}`, { headers: authHeader() });
